import React from 'react';
import PropTypes from 'prop-types';
import ExternalRedirect from '../components/redirect/ExternalRedirect';
import config from '../../config';
import { seoLocationRedirectPath } from '../utils/seoLocationRoutes';

// FEWD-336: the bare /{location} landing pages are discontinued in favor of
// the new app's /locations pages. This must stay a CLIENT redirect — these
// catch-all routes only match when no other SPA route did, a condition the
// Express layer cannot reproduce. The suffixed SEO shapes get true 301s in
// src/server/index.js; this component is their client-navigation fallback.
const SeoLocationRedirect = ({ location }) => (
    <ExternalRedirect to={`${config.nextAppHost}${seoLocationRedirectPath(location.pathname)}`} />
);

SeoLocationRedirect.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
};

export default SeoLocationRedirect;
